import { jsxs as N, jsx as s } from "react/jsx-runtime";
import { periodDatePickerTheme as e } from "./theme.js";
import { DAYS_OF_WEEK as S } from "./types.js";
import { cn as k } from "../../utils/cn.js";
const M = ({
  days: v,
  monthLabel: d,
  minDate: l,
  maxDate: p,
  isStartDate: c,
  isEndDate: h,
  isInRange: w,
  handleDateClick: g,
  setHoveredDate: m,
  isPeriodDisabled: u
}) => /* @__PURE__ */ N("div", { className: e.popover.view.month.base, children: [
  /* @__PURE__ */ s("div", { className: e.popover.view.month.label, children: d }),
  /* @__PURE__ */ s("div", { className: e.popover.view.month.weekdays.base, children: S.map((o) => /* @__PURE__ */ s(
    "div",
    {
      className: e.popover.view.month.weekdays.item,
      children: o
    },
    o
  )) }),
  /* @__PURE__ */ s("div", { className: "grid grid-cols-7 gap-1", children: v.map((o, b) => {
    if (!o)
      return /* @__PURE__ */ s("div", { className: "h-9" }, `empty-${b}`);
    const t = c(o), a = h(o), n = w(o), f = o.toDateString() === (/* @__PURE__ */ new Date()).toDateString(), i = l && o < l || p && o > p, r = !i && (u?.(o) ?? !1);
    return /* @__PURE__ */ s(
      "button",
      {
        onClick: () => !i && !r && g(o),
        onMouseEnter: () => m(o),
        onMouseLeave: () => m(null),
        disabled: !!i,
        className: k(
          e.popover.view.month.dates.base,
          (i || r) && e.popover.view.month.dates.disabled,
          r && "cursor-not-allowed",
          t && e.popover.view.month.dates.start,
          a && e.popover.view.month.dates.end,
          n && e.popover.view.month.dates.inRange,
          t && n && "rounded-l-lg",
          a && n && "rounded-r-lg",
          !t && !a && !n && !i && !r && "text-foreground",
          f && e.popover.view.month.dates.today
        ),
        children: o.getDate()
      },
      o.toISOString()
    );
  }) })
] });
export {
  M as Month
};
